import { render, staticRenderFns } from "./CandidateLangProficiency.vue?vue&type=template&id=008463a8&"
import script from "./CandidateLangProficiency.vue?vue&type=script&lang=js&"
export * from "./CandidateLangProficiency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports